<template>
	<b-card>
		<div class="hidden-print">
			<b-row style="margin-top: 10px; margin-bottom: 10px">
				<b-col cols="2">
					<b>Даты прихода:</b>
				</b-col>
				<b-col>
					<date-picker
						v-model="startRegDate"
						lang="ru"
						style="width: 100%"
						:placeholder="$t('Дата начала')"
						valueType="format"
						format="DD-MM-YYYY"/>
				</b-col>
				<b-col>
					<date-picker
						v-model="endRegDate"
						lang="ru"
						style="width: 100%"
						:placeholder="$t('Дата окончания')"
						valueType="format"
						format="DD-MM-YYYY"/>
				</b-col>
				<b-col align="center">
					<b-button @click="getItems" :disabled="loading" variant="dark" class="fa fa-search mr-2 ml-2"/>
					<vs-dropdown vs-custom-content vs-trigger-click>
						<b-link href.prevent class="card-header-action btn-setting">
							<b-button class="fa fa-th" variant="dark"/>
						</b-link>
						<vs-dropdown-menu class="columns-dropdown">
							<vs-dropdown-item v-for="(ind, i) in fields" :key="i">
								<b-checkbox v-model="ind.visible">{{ind.label}}</b-checkbox>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
					<download-excel  :data="items" :fields="computedJsonToExcel" variant="primary"  :disabled="loading" style="cursor: pointer" class="ml-2 btn btn-outline-primary" name="Остатки по импорт">
						<b-spinner v-if="loading" small class="mr-2"/><strong>{{ $t('excel-export.download-excel') }}</strong>
					</download-excel>
				</b-col>
			</b-row>
			<hr class="mt-1">
		</div>
		<b-card-body class="marginPage">
			<b-row class="mt-4">
				<b-col>
					<b-table :items="items" :fields="computedFields" id="gridContainer" :busy="loading" :responsive="true" small bordered show-empty striped hover  no-footer-sorting  label-sort-asc="" label-sort-desc="" label-sort-clear="">
						<template #table-busy>
							<div class="text-center my-2">
								<b-spinner small class="mr-2"/><strong>Loading...</strong>
							</div>
						</template>
						<template #cell(index)="data">
							{{ data.index+1 }}
						</template>
					</b-table>

				</b-col>
			</b-row>
		</b-card-body>
	</b-card>
</template>
<script>
import Multiselect from "vue-multiselect";
import {BTable, VBTable} from "bootstrap-vue";
import {BOverlay} from 'bootstrapVue2';
import ReportService from "./report.service";

export default {
	name: "Остатки по импорт",
	components: {Multiselect, BTable, VBTable,BOverlay},
	data() {
		return {
  			items: [],
			fields: [
				{key: 'index', label: '№', class: 'text-center', visible: true},
				{key: 'numberGtd', label: this.$t('Номер ГТД'), class: 'text-center', visible: true,sortable: true},
				{key: 'regNumber', label: this.$t('Рег. номер'), class: 'text-center', visible: true,sortable: true},
				{key: 'itemName', label: this.$t('Наименование товара'), class: 'text-center', visible: true,sortable: true},
				{key: 'regDate', label: this.$t('Дата регистрации'), class: 'text-center', visible: true,sortable: true},
				{key: 'remaining', label: this.$t('Остаток'), class: 'text-center', visible: true,sortable: true},
				{key: 'incomePrice', label: this.$t('Приходная цена'), class: 'text-center', visible: true,sortable: true},
				{key: 'invoicePrice', label: this.$t('Инвойс цена'), class: 'text-center', visible: true,sortable: true},
				{key: 'totalPriceRemaining', label: this.$t('Итоговоя сумма'), class: 'text-center', visible: true,sortable: true},
			],
			loading: false,
			startRegDate:'',
			endRegDate:'',
		};
	},
	methods: {
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function(s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function(s, c) {
					return s.replace(/{(\w+)}/g, function(m, p) {
						return c[p];
					})
				}
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		print() {
			window.print();
		},
		getItems() {
			this.loading = true
			this.items = []
			if (this.startRegDate !== "" && this.endRegDate !== "") {
				let data = {
					startRegDate: this.startRegDate,
					endRegDate: this.endRegDate,
				}
				ReportService.getReportItemsNew3(data).then(res => {
					this.items = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.loading = false
				this.$vs.notify({
					text: "Выберите Подразделение с периодом",
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		}
	},
	created() {},
	computed: {
		computedJsonToExcel(){
			let visibleFields = {};
			this.fields.forEach(t =>{
				if (t.visible === true){
					visibleFields[t.label] = t.key;
				}
			})
			return visibleFields;
		},
		computedFields() {
			let tmp = []
			this.fields.forEach(t => {
				if (t.visible)
					tmp.push(t)
			})
			return tmp
		},

	},
	watch: {
		'departmentId': {
			handler(newValue) {
				this.depIds = []
				this.depNames = []
				newValue.forEach(res => {
					this.depIds.push(res.id)
					this.depNames.push(res.name)
				})
			}
		},
		'allDep': {
			handler(res) {
				if (res) {
					this.depIds = []
					this.departments.forEach(r => {
						this.depIds.push(r.id)
					})
				}
			}
		}
	}
}
</script>

<style scoped>

@page  {
	margin: 1cm;
}

@media print {
	.hidden-print {
		display: none;
	}
	.marginPage {
		margin: 0 30px 0 40px;
	}
}
</style>
